var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5V11H1V5H3ZM5 11C4.73478 11 4.48043 10.8946 4.29289 10.7071C4.10536 10.5196 4 10.2652 4 10V5C4 4.725 4.11 4.475 4.295 4.295L7.585 1L8.115 1.53C8.25 1.665 8.335 1.85 8.335 2.06L8.32 2.215L7.845 4.5H11C11.555 4.5 12 4.95 12 5.5V6.5C12 6.63 11.975 6.75 11.93 6.865L10.42 10.39C10.27 10.75 9.915 11 9.5 11H5ZM5 10H9.515L11 6.5V5.5H6.61L7.175 2.84L5 5.015V10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.68a83dfb.svg";
export { ForwardRef as ReactComponent };